import gsap from 'gsap';
import projectsSlider from './projects-slider';
import projectAnimations from './project-animations';

const dynamic = () => {
    /* HTML Elements */
    let elLinks;
    const elContainer = document.querySelector('.js-global-container');
    const elNavigation = document.querySelector('.c-navigation');

    /* CONSTANTS */
    const CLASS_TRANSITION = 'is-transition';

    /* Variables */
    let prevHref = window.location.href;
    let currentPage = document.body.getAttribute('data-pageid');
    let projectAnimationContr;
    let sliderObject = projectsSlider();

    function init () {
        if (!elNavigation) return;

        projectAnimationContr = projectAnimations();
        attachEvents();
        reinit();
        setTimeout(pagesAnimations);
    }

    function attachEvents () {

        // When browser history changes
        window.onpopstate = (e) => {
            if (prevHref !== window.location.href) {
                loadProject(window.location.href, document.body);
            }
        };
    }

    function reinit() {
        pagesSetup();
        elLinks = document.querySelectorAll('[data-internal]');
        for (let i = 0; i < elLinks.length; i++) {
            elLinks[i].addEventListener('click', onLinkClick);
        }
        projectAnimationContr.start();
        sliderObject.reinit();
    }

    function scrollTop () {
        const scrollTransition = {a:1};
        const currentScroll = window.pageYOffset;
        gsap.to(scrollTransition, {
            duration: 0.48,
            a: 0,
            onUpdate: () => {
                window.scrollTo(0, window.pageYOffset * scrollTransition.a);
            }
        });
    }

    function onLinkClick (e) {
        if (e.ctrlKey) return;
        e.preventDefault();
        const url = this.getAttribute('href');
        if (prevHref !== url) {
            loadProject(url, this);
        }
        return false;
    }

    function loadProject (url, elLink) {
        const request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
        request.setRequestHeader('Accept', 'application/json')

        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                // Success!
                const data = JSON.parse(this.response);
                // if (elLink.classList.contains('js-project-link')) {
                updateNav(data.navWhite);
                appendContent(data.content, data.navWhite);
                updateHistory(url, data.pageID);
            } else {
                // We reached our target server, but it returned an error
                onLoadingError()
            }
        };

        request.onerror = onLoadingError;

        request.send();
    }

    function onLoadingError () {
        console.log('Error');
    }

    function appendContent (content, navWhite) {
        // Fade out container
        gsap.to('body', {
            duration: 0.5,
            opacity: 0,
            onComplete: () => {
                elContainer.innerHTML = content;
                updateNav(navWhite);
                window.scrollTo(0, 0);
                gsap.to('body', {
                    opacity: 1,
                    duration: 0.5,
                    ease: 'power2.out',
                    delay: 0.3,
                    onComplete () {
                        afterNewContent();
                        pagesAnimations();
                    }
                });
            }
        });
    }

    function afterNewContent () {
        reinit();
    }

    function updateNav(navWhite) {
        if (navWhite) {
            elNavigation.classList.add('c-navigation--white');
        } else {
            elNavigation.classList.remove('c-navigation--white');
        }
    }

    function updateHistory (url, pageID) {
        window.history.pushState({}, '', url);
        prevHref = window.location.href;

        currentPage = pageID;
        document.body.setAttribute('data-pageid', pageID);
    }

    function pagesAnimations () {
        if (currentPage === 'about') {
            aboutAnimation();
        }
    }

    function pagesSetup () {
       if (currentPage === 'home') {
            document.querySelector('.c-navigation [data-page="home"]').classList.add('c-navigation__link--green');
            document.querySelector('.c-navigation [data-page="about"]').classList.remove('c-navigation__link--green');
        } else if (currentPage === 'about') {
            document.querySelector('.c-navigation [data-page="about"]').classList.add('c-navigation__link--green');
            document.querySelector('.c-navigation [data-page="home"]').classList.remove('c-navigation__link--green');
        }
    }

    function aboutAnimation () {
        const elTitle = document.querySelector('.c-about__title');
        if (elTitle) {
            elTitle.classList.add('start-transition');
        }
    }

    function getScrollBarWidth () {
        const outer = document.createElement('div');
        outer.style.overflow = 'scroll';
        outer.style.width = '100px';
        // Add inner div
        const inner = document.createElement('div');
        inner.style.width = '100%';
        outer.appendChild(inner);
        document.body.appendChild(outer);

        const width = outer.offsetWidth - inner.offsetWidth;
        document.body.removeChild(outer);
        return width;
    }

    return {
        init: init
    }
};

export default dynamic;



// WEBPACK FOOTER //
// ./web/assets/src/js/modules/dynamic.js